import type { PortfolioPayload } from '../types'

export const demoPortfolio: PortfolioPayload = {
  profile: {
    name: '练舒涵',
    initials: 'LSH',
    headline: '游戏交互设计师 · 产品体验设计师',
    bio: '具备设计与产品双背景，能够从需求分析、方案设计到落地推进完成完整产品流程。拥有游戏 UI/UX、设计规范与跨领域协作经验，擅长将复杂需求沉淀为可复用的系统与工具，并借助 Swift、Figma Make、Gemini 等技术和 AI 工具快速验证方案。',
    location: '中国',
    email: '3180101247@zju.edu.cn',
    phone: '18888913451',
    availability: '游戏交互 / 产品体验 / 创新设计',
    resume_url: '/resume/lian-shuhan-resume-0406.pdf',
    years_experience: '3+',
    project_count: '7',
    skills: ['游戏 UI/UX', '需求分析', '设计系统', '多端适配', 'Figma', 'Figma Make', 'Swift 原型', 'Gemini', '用户研究', '数据分析', '视频制作', '跨团队协作'],
    portfolio_links: [
      { label: '旧版作品集', url: 'https://pan.baidu.com/s/1s38DqH9LeUP8p_07gLvE9A?pwd=rfsy' },
      { label: '新片场主页', url: 'https://www.xinpianchang.com/u11560499' },
    ],
    education: [
      { school: '中国美术学院', degree: '硕士 · 艺术赋能与科技创新设计', department: '创新设计学院', period: '2022.09 - 2025.06' },
      { school: '浙江大学', degree: '本科 · 工业设计', department: '计算机科学与技术学院', period: '2018.09 - 2022.06' },
    ],
    experiences: [
      {
        company: '叠纸游戏', title: '游戏交互设计师', project: '《无限暖暖》项目组', period: '2024.07 - 2025.02 / 2025.07 - 至今',
        bullets: [
          '参与活动系统需求分析，从策划阶段判断功能复用或定制方案，提升系统复用效率。',
          '负责多类活动玩法的 UI/UX 设计，覆盖局内外核心流程并推动方案落地上线。',
          '主导活动系统设计规范建设，整合玩法与关卡文档，形成统一规范体系。',
          '优化历史活动的导航结构、主机端焦点逻辑及信息提示机制，沉淀标准化活动模板。',
          '搭建并维护 Figma 组件库，提高团队协作效率与设计一致性。',
          '参与活动与商业化模块版本跑测，协同多团队推进问题定位与迭代闭环。',
          '探索 Figma Make 在交互设计与原型验证中的应用，提高方案验证效率。',
        ],
      },
      {
        company: '24工作室', title: '交互策划', project: '《永劫无间》项目组', period: '2023.05 - 2024.01',
        bullets: [
          '独立负责功能从需求承接、方案设计到上线验收的完整流程。',
          '兼顾 PC / 主机多端及多语言适配，保障不同场景下的体验一致性。',
          '跨策划、开发、测试协作推进需求，实现功能闭环交付。',
          '从 0 到 1 设计 3D 大厅玩法总览、大厅拍照、肉鸽灵器图鉴等系统。',
          '优化乐器系统、肉鸽结算、特权网吧等既有系统体验。',
        ],
      },
      {
        company: '网易（杭州）网络有限公司', title: '用户体验设计实习生', project: '雷火 UX 用户体验中心', period: '2022.07 - 2022.12',
        bullets: [
          '完成《永劫无间》教学系统、PVE 通行证、战斗界面等多端 UI/UX 设计与优化。',
          '参与 Xbox 等待界面小游戏设计及像素动画制作，完善局内体验细节。',
          '独立完成微信小程序与网页类产品的交互设计。',
          '参与用户体验测试与数据反馈分析，持续提出并验证优化建议。',
          '输出 UX 分析内容并发布于团队公众号，阅读量 5k+。',
        ],
      },
    ],
  },
  projects: [
    {
      id: 'resume-1', slug: 'infinity-nikki-event-system', title: '《无限暖暖》活动系统设计', category: 'game-interaction',
      summary: '覆盖局内外活动玩法、主机焦点逻辑、标准化模板与设计系统建设。', role: '游戏交互设计师', period: '2024 - 至今',
      tags: ['游戏 UI/UX', '活动系统', 'Design System', '主机适配'],
      content: '参与活动系统需求分析，从策划阶段判断功能复用或定制方案。负责多类活动玩法的 UI/UX 设计，覆盖局内外核心流程，并推动方案落地上线。\n\n主导活动系统设计规范建设，统一导航结构、主机端焦点逻辑与信息提示机制；同时搭建并维护 Figma 组件库，沉淀可复用的活动模板。',
      highlights: ['建立活动系统统一设计规范', '覆盖局内与活动大厅等核心模块', '通过组件库与 AI 原型提升验证效率'], featured: true, status: 'published', sort_order: 1,
    },
    {
      id: 'resume-2', slug: 'naraka-ux-optimization', title: '《永劫无间》用户体验优化设计', category: 'game-interaction',
      summary: '围绕玩法发现、长期目标、多端操作与商业化体验，完成 5 类核心功能从问题分析、信息架构到界面落地的系统设计。', role: '交互策划 / 用户体验设计', period: '2023.05.25 - 2024.01.31',
      tags: ['3D 大厅', '系统设计', 'PC / Xbox', '信息架构', '运营活动'],
      cover_url: '/projects/naraka-ux/page-01.webp',
      cover_alt: '《永劫无间》用户体验优化设计项目封面',
      content: '项目聚焦《永劫无间》3D 大厅与 PVE 玩法中的复杂系统体验。我独立承接需求分析、功能架构、玩家流程、交互框架与视觉落地，并同时考虑键鼠、手柄和多语言场景。\n\n01 / 3D 大厅玩法总览：针对玩家难以理解大厅玩法机制与空间位置的问题，以地图可视化、玩法详情、导航指引和正反馈构建完整的发现路径。\n\n02 / 乐器功能系统：通过熟练度、等级考试、奖励预览与演奏循环，提升乐器功能的目标感、使用频率和社交价值。\n\n03 / 肉鸽祝福图鉴：建立可预览、可收集的赛季长期目标，打通玩法入口、祝福选择、战局结算与图鉴进度反馈。\n\n04 / 运营与商业化：覆盖赛季活动、预热活动、充值付费与网吧权益等功能，在信息表达与转化目标之间维持清晰操作路径。\n\n05 / Xbox 像素小游戏：为缓解匹配等待时间过长造成的流失，设计等待界面小游戏，并完成主要角色连招动画绘制、资源优化与拼接。',
      highlights: ['完成 5 类系统的端到端体验设计', '打通 3D 大厅玩法发现与地图导航路径', '建立乐器熟练度和肉鸽图鉴的长期目标反馈', '兼顾键鼠、手柄及 Xbox 等多端操作'],
      gallery: [
        { image_url: '/projects/naraka-ux/page-02.webp', image_alt: '3D 大厅玩法总览功能的问题、解法与玩家流程', caption: '3D 大厅玩法总览 · 问题定义、功能架构与玩家流程' },
        { image_url: '/projects/naraka-ux/page-03.webp', image_alt: '3D 大厅玩法总览的信息结构与界面层级', caption: '3D 大厅玩法总览 · 信息结构与界面层级' },
        { image_url: '/projects/naraka-ux/page-04.webp', image_alt: '3D 大厅玩法总览的界面框架', caption: '3D 大厅玩法总览 · 总览页框架' },
        { image_url: '/projects/naraka-ux/page-05.webp', image_alt: '3D 大厅玩法详情与键鼠手柄交互框架', caption: '3D 大厅玩法总览 · 详情页与多端交互框架' },
        { image_url: '/projects/naraka-ux/page-06.webp', image_alt: '3D 大厅地图导航和操作提示视觉稿', caption: '3D 大厅玩法总览 · 地图导航视觉方案' },
        { image_url: '/projects/naraka-ux/page-07.webp', image_alt: '3D 大厅玩法详情界面视觉稿', caption: '3D 大厅玩法总览 · 玩法详情视觉方案' },
        { image_url: '/projects/naraka-ux/page-08.webp', image_alt: '乐器功能系统的问题、解法与玩家流程', caption: '乐器功能系统 · 问题定义、功能架构与玩家流程' },
        { image_url: '/projects/naraka-ux/page-09.webp', image_alt: '乐器功能系统的信息结构', caption: '乐器功能系统 · 信息结构' },
        { image_url: '/projects/naraka-ux/page-10.webp', image_alt: '乐器功能系统的页面流程框架', caption: '乐器功能系统 · 页面流程' },
        { image_url: '/projects/naraka-ux/page-11.webp', image_alt: '乐器熟练度界面信息优化', caption: '乐器功能系统 · 熟练度信息可视化' },
        { image_url: '/projects/naraka-ux/page-12.webp', image_alt: '乐器演奏按键布局与操作框架', caption: '乐器功能系统 · 演奏操作框架' },
        { image_url: '/projects/naraka-ux/page-13.webp', image_alt: '乐器熟练度与奖励界面视觉稿', caption: '乐器功能系统 · 熟练度与奖励视觉方案' },
        { image_url: '/projects/naraka-ux/page-14.webp', image_alt: '乐器演奏界面视觉稿', caption: '乐器功能系统 · 演奏界面视觉方案' },
        { image_url: '/projects/naraka-ux/page-15.webp', image_alt: '肉鸽祝福图鉴系统的功能架构与玩家流程', caption: '肉鸽祝福图鉴 · 需求、结构与玩家流程' },
        { image_url: '/projects/naraka-ux/page-16.webp', image_alt: '肉鸽祝福图鉴主界面框架', caption: '肉鸽祝福图鉴 · 图鉴主界面框架' },
        { image_url: '/projects/naraka-ux/page-17.webp', image_alt: '肉鸽祝福三选一与收集提示框架', caption: '肉鸽祝福图鉴 · 祝福选择与收集反馈' },
        { image_url: '/projects/naraka-ux/page-18.webp', image_alt: '战局结算图鉴进度展示框架', caption: '肉鸽祝福图鉴 · 战局结算信息框架' },
        { image_url: '/projects/naraka-ux/page-19.webp', image_alt: '肉鸽祝福图鉴界面视觉稿', caption: '肉鸽祝福图鉴 · 图鉴与入口视觉方案' },
        { image_url: '/projects/naraka-ux/page-20.webp', image_alt: '肉鸽战局结算界面视觉稿', caption: '肉鸽祝福图鉴 · 战局结算视觉方案' },
        { image_url: '/projects/naraka-ux/page-21.webp', image_alt: '赛季活动、充值付费和网吧权益界面', caption: '运营功能设计 · 活动、付费与网吧权益' },
        { image_url: '/projects/naraka-ux/page-22.webp', image_alt: 'Xbox 等待界面像素小游戏与角色动画资源', caption: 'Xbox 像素小游戏 · 等待体验与动画资源' },
      ],
      featured: true, status: 'published', sort_order: 2,
    },
    {
      id: 'resume-3', slug: 'emoody', title: 'Emoody 情绪记录 App', category: 'student-project',
      summary: '从产品定义到 Swift 可运行原型，探索情绪数据反馈与 AR 沉浸表达。', role: '产品设计 / 交互原型 / Swift', period: '个人项目',
      tags: ['iOS 原型', '情绪记录', '数据可视化', 'AR 交互'],
      content: '从 0 到 1 定义情绪记录、分析与反馈等核心功能及整体交互流程。基于用户情绪记录场景，设计数据可视化与反馈机制。\n\n使用 Swift 实现可运行的 iOS 交互原型，验证关键交互方案，并引入 AR 交互探索沉浸式情绪反馈。',
      highlights: ['完成产品定义与完整交互流程', '实现可运行 Swift 原型', '探索 AR 情绪反馈方式'], featured: true, status: 'published', sort_order: 3,
    },
    {
      id: 'resume-4', slug: 'vova-ux-optimization', title: 'VOVA 电商体验优化', category: 'product-design',
      summary: '基于体验分析、竞品研究与用户路径拆解，优化关键信息结构和转化流程。', role: 'UX 策略 / 转化优化', period: '项目经历',
      tags: ['UX 策略', '竞品分析', '信息架构', '转化优化'],
      content: '对平台进行系统性体验分析，识别核心交互与信息结构问题。通过竞品分析与用户路径拆解，定位关键转化流程中的体验障碍。\n\n输出 UI/UX 优化方案，重构信息层级与交互逻辑，提升操作效率。',
      highlights: ['完成系统性体验诊断', '拆解关键用户转化路径', '重构信息层级与交互逻辑'], featured: false, status: 'published', sort_order: 4,
    },
    {
      id: 'resume-5', slug: 'movie-poster-data-exhibition', title: '美国电影海报参数化展览', category: 'student-project',
      summary: '结合 IMDB 数据分析、可视化与变色油墨，构建实体交互展览体验。', role: '数据分析 / 交互装置设计', period: '学生项目',
      tags: ['Pandas', '数据可视化', '实体交互', '展览设计'],
      content: '基于 IMDB 数据进行筛选与聚类分析，构建展览数据结构；设计通过触摸触发信息反馈的数据可视化装置。\n\n结合变色油墨材料特性，实现物理交互与信息呈现的融合。',
      highlights: ['建立 IMDB 数据分析结构', '设计触摸触发交互装置', '融合数字信息与材料反馈'], featured: false, status: 'published', sort_order: 5,
    },
    {
      id: 'resume-6', slug: 'hi-air-toy', title: 'Hi! Air 孩子气', category: 'student-project',
      summary: '以气动与自动化为核心，完成软硬件结合的益智玩具产品原型。', role: '产品设计 / 硬件交互', period: '学生项目',
      tags: ['硬件交互', '产品原型', '气动结构', '展示设计'],
      content: '参与产品从概念构思到原型制作的完整设计流程，探索气动与自动化结合的交互方式，并负责部分结构实现及展示内容制作。',
      highlights: ['完成软硬件结合的产品原型', '探索气动自动化交互', '覆盖结构与展示内容实现'], featured: false, status: 'published', sort_order: 6,
    },
    {
      id: 'resume-7', slug: 'fish-swarms', title: 'Fish Swarms 海上油污处理系统', category: 'student-project',
      summary: '将鱼群算法转化为面向海洋环境问题的概念产品与系统方案。', role: '概念产品 / 系统设计', period: '学生项目',
      tags: ['算法应用', '系统设计', '环境议题', '概念产品'],
      content: '基于鱼群算法进行海上油污处理系统的概念设计，探索环境问题解决方案，并参与整体方案构建、设计表达与项目呈现。',
      highlights: ['将技术概念转化为产品方案', '完成系统概念与整体表达', '全国大学生工业设计大赛优秀奖'], featured: false, status: 'published', sort_order: 7,
    },
  ],
}
